import { render, staticRenderFns } from "./ConflictReport.vue?vue&type=template&id=4e547944&"
import script from "./ConflictReport.vue?vue&type=script&lang=js&"
export * from "./ConflictReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports